import React, { useMemo } from "react";
// import { useWindowSize } from "react-use";
import classnames from "classnames";

import "./styles.less";

export const Modal = (props) => {
  const { children = null, visible } = props;
  const classmodal = useMemo(() => {
    return classnames([
      {
        modal: true,
        hidden: !visible,
      },
      props.className,
    ]);
  }, [props.className, visible]);
  return (
    <div className={classmodal}>
      <div className="mask"></div>
      <div className="modal-box">{children}</div>
    </div>
  );
};
